import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  isLoggedUserSelector,
  loggedUserIdSelector,
} from '../../../redux/context/selectors';
import { showDependentCreateModal } from '../../../redux/ui/popup';
import { selectCaregiverCirclePending } from '../../../redux/circles/selectors';
import { selectGuardianDependentsList, selectIsLoadingGuardianDependents } from '../../../redux/profiles/selectors';
import { actions as uiDrawerActions } from '../../../redux/ui/drawer';

const mapStateToProps = state => ({
  isLoggedUser: isLoggedUserSelector(state),
  loggedUserId: loggedUserIdSelector(state),
  caregiverCirclePending: selectCaregiverCirclePending(state),
  guardianDependentsList: selectGuardianDependentsList(state),
  guardianCirclePending: selectIsLoadingGuardianDependents(state),
});

const mapDispatchToProps = {
  toggleDrawer: uiDrawerActions.toggleVisibility,
  showDependentCreatedModal: showDependentCreateModal,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ caregiverCirclePending, guardianCirclePending }) => ({
    pending: caregiverCirclePending || guardianCirclePending,
  })),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Navigation/enhance.js